import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import { tabListener } from "../../../lib/events/tabListener";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles, globalClasses } from "../Toggle.styles";
var colorWarningShown = false;
export var Toggle = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Toggle, _React$Component);

  function Toggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.theme = void 0;
    _this.input = null;

    _this.focus = function () {
      if (_this.input) {
        tabListener.isTabPressed = true;

        _this.input.focus();
      }
    };

    _this.inputRef = function (element) {
      _this.input = element;
    };

    _this.handleChange = function (event) {
      if (_this.props.onValueChange) {
        _this.props.onValueChange(event.target.checked);
      }

      if (_this.isUncontrolled()) {
        _this.setState({
          checked: event.target.checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      if (tabListener.isTabPressed) {
        _this.setState({
          focusByTab: true
        });
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.setState({
        focusByTab: false
      });
    };

    _this.state = {
      focusByTab: false,
      checked: props.defaultChecked
    };
    return _this;
  }

  var _proto = Toggle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus) {
      tabListener.isTabPressed = true;
      this.focus();
    }
  }
  /**
  * @public
  */
  ;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _cx, _cx2, _cx4, _cx5, _cx6;

    var _this$props = this.props,
        children = _this$props.children,
        captionPosition = _this$props.captionPosition,
        warning = _this$props.warning,
        error = _this$props.error,
        loading = _this$props.loading,
        color = _this$props.color;
    var disabled = this.props.disabled || loading;
    var checked = this.isUncontrolled() ? this.state.checked : this.props.checked;
    var containerClassNames = cx(styles.container(this.theme), (_cx = {}, _cx[styles.containerDisabled(this.theme)] = !!disabled, _cx[globalClasses.container] = true, _cx[globalClasses.containerDisabled] = !!disabled, _cx[globalClasses.containerLoading] = loading, _cx));
    var labelClassNames = cx(styles.root(this.theme), (_cx2 = {}, _cx2[styles.rootLeft()] = captionPosition === 'left', _cx2[styles.disabled()] = !!disabled, _cx2));
    var caption = null;

    if (children) {
      var _cx3;

      var captionClass = cx(styles.caption(this.theme), (_cx3 = {}, _cx3[styles.captionLeft(this.theme)] = captionPosition === 'left', _cx3));
      caption = /*#__PURE__*/React.createElement("span", {
        className: captionClass
      }, children);
    }

    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("label", {
      className: labelClassNames
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(styles.outline(this.theme), (_cx4 = {}, _cx4[styles.isWarning(this.theme)] = !!warning, _cx4[styles.isError(this.theme)] = !!error, _cx4[styles.focused(this.theme)] = !disabled && !!this.state.focusByTab, _cx4))
    }, /*#__PURE__*/React.createElement("span", {
      className: cx(styles.wrapper(this.theme))
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: checked,
      onChange: this.handleChange,
      className: styles.input(this.theme),
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      ref: this.inputRef,
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: containerClassNames,
      style: checked && color && !disabled ? {
        backgroundColor: color,
        boxShadow: "inset 0 0 0 1px " + color
      } : undefined
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(styles.activeBackground(), globalClasses.background, (_cx5 = {}, _cx5[styles.activeBackgroundLoading(this.theme)] = loading, _cx5)),
      style: checked && color && !disabled ? {
        backgroundColor: color,
        boxShadow: "inset 0 0 0 1px " + color
      } : undefined
    })), /*#__PURE__*/React.createElement("div", {
      className: cx(styles.handle(this.theme), globalClasses.handle, (_cx6 = {}, _cx6[styles.handleDisabled(this.theme)] = disabled, _cx6))
    }))), caption));
  };

  _proto.isUncontrolled = function isUncontrolled() {
    return this.props.checked === undefined;
  };

  return Toggle;
}(React.Component);
Toggle.__KONTUR_REACT_UI__ = 'Toggle';
Toggle.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  warning: PropTypes.bool,
  onValueChange: PropTypes.func,
  color: function color(props) {
    if (props.color && !colorWarningShown) {
      warning(false, "[Toggle]: prop 'color' is deprecated. Please, use theme variable 'toggleBgChecked' instead. ");
      colorWarningShown = true;
    }
  }
};
Toggle.defaultProps = {
  disabled: false,
  loading: false,
  captionPosition: 'right'
};